var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block shadow-lg bg-white p-8 mb-6"},[(_vm.loading)?_c('div',[_c('loader')],1):_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }